module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ttttt"
  }, [_c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footTop page-content flexbetween"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "beianh",
    on: {
      "click": _vm.getbtn
    }
  }, [_vm._v("备案号：豫ICP备20006643号-1")]), _vm._v(" "), _c('div', {
    staticClass: "rightList flexbetween"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      staticClass: "child",
      on: {
        "click": function($event) {
          return _vm.todetail(index)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "footBot page-content flexleft"
  }, [_c('div', {
    staticClass: "left"
  }, [(_vm.wxQrcodeUrls[0]) ? _c('img', {
    attrs: {
      "src": _vm.$index.addurl(_vm.wxQrcodeUrls[0]),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "txt"
  }, [_vm._v("微信公众号")])]), _vm._v(" "), _c('div', {
    staticClass: "left",
    staticStyle: {
      "margin-left": "20px"
    }
  }, [(_vm.wxQrcodeUrls[1]) ? _c('img', {
    attrs: {
      "src": _vm.$index.addurl(_vm.wxQrcodeUrls[1]),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "txt"
  }, [_vm._v("微信视频号")])]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "txt"
  }, [_vm._v("免费服务热线")]), _vm._v(" "), _c('div', {
    staticClass: "phone"
  }, [_vm._v(_vm._s(_vm.data.telephone))])]), _vm._v(" "), _c('div', {
    staticClass: "map animation-from-left-0"
  }, [_c('el-amap', {
    ref: "map",
    attrs: {
      "vid": "amapDemo",
      "amap-manager": _vm.amapManager,
      "center": _vm.center,
      "expandZoomRange": "true",
      "zoom": _vm.zoom,
      "plugin": _vm.plugin,
      "pitch": 66
    }
  }, [_c('el-amap-marker', {
    attrs: {
      "vid": "amapDemo",
      "position": _vm.center
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "txt"
  }, [_vm._v("地址")]), _vm._v(" "), _c('div', {
    staticClass: "address"
  }, [_vm._v(_vm._s(_vm.data.address))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/image/logo.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/image/phone.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon flexbetween"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/image/address.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24f7242f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/foot/footer.vue
// module id = 1085
// module chunks = 1